export default {
  // GET Requests //

  // Gets all goal post data
  async getGoalPostData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let companyGoals;
    let userGoals;

    try {
      companyGoals = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      companyGoals = await companyGoals.json();

      userGoals = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/user-goals/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      userGoals = await userGoals.json();
    } catch (err) {
      return 500;
    }

    let companyReportsPayload = [];
    let companyGoalsPayload = [];
    let departmentGoalsPayload = [];

    companyGoals.forEach((goal) => {
      companyReportsPayload.push({
        projectId: goal._id,
        companyId: goal.companyId,
        title: goal.title,
        status: goal.status,
        endDate: goal.endDate,
        created: goal.created,
      });

      goal.companyGoals.forEach((companyGoal) => {
        companyGoal.projectId = goal._id;
        companyGoalsPayload.push(companyGoal);
      });

      goal.departments.forEach((department) => {
        department.projectId = goal._id;
        departmentGoalsPayload.push(department);
      });
    });

    context.commit("companyReports", companyReportsPayload);
    context.commit("companyGoals", companyGoalsPayload);
    context.commit("departmentGoals", departmentGoalsPayload);

    context.commit("userReports", userGoals.reports);
    context.commit("userGoals", userGoals.userGoals);
    context.commit("goalPostsTimestamp");

    return 200;
  },
  // POST Requests //

  // Create a project
  async postAddProject(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/add-project",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            title: payload.title,
            endDate: payload.endDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyReports = context.state.companyReports;
    companyReports.push({
      projectId: response._id,
      companyId: response.companyId,
      title: response.title,
      status: response.status,
      endDate: response.endDate,
      created: response.created,
    });
    context.commit("companyReports", companyReports);

    return 201;
  },
  // Create a company goal
  async postAddCompanyGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/add-company-goal",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            title: payload.title,
            context: payload.context,
            achievement: payload.achievement,
            value: payload.value,
            completionDate: payload.completionDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyGoals = context.state.companyGoals;
    response.companyGoal.projectId = response.projectId;
    companyGoals.push(response.companyGoal);
    context.commit("companyGoals", companyGoals);

    return 201;
  },
  // Create department goal
  async postAddDepartmentGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/add-department-goal",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            title: payload.title,
            departmentId: payload.departmentId,
            context: payload.context,
            achievement: payload.achievement,
            value: payload.value,
            completionDate: payload.completionDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    let departmentGoal = response.departmentGoal;
    departmentGoal.projectId = response.projectId;

    let departmentFound = false;
    let departmentGoals = context.state.departmentGoals;
    for (let i = 0; i < departmentGoals.length; i++) {
      if (
        departmentGoals[i].projectId == departmentGoal.projectId &&
        departmentGoals[i].departmentId == departmentGoal.departmentId
      ) {
        departmentGoals[i] = departmentGoal;
        departmentFound = true;
        break;
      }
    }
    if (!departmentFound) {
      departmentGoals.push(departmentGoal);
    }

    context.commit("departmentGoals", departmentGoals);

    return 201;
  },
  // Create a company goal
  async postAddUserGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/add-goal",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            departmentId: payload.departmentId,
            userId: payload.userId,
            title: payload.title,
            context: payload.context,
            achievement: payload.achievement,
            value: payload.value,
            completionDate: payload.completionDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let userGoals = context.state.userGoals;
    response.goal.userId = response.userId;
    userGoals.push(response.goal);
    context.commit("userGoals", userGoals);

    return 201;
  },
  // Create reports for a specific department
  async postDepartmentReports(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/publish-department-reports",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let departmentGoals = response.department;
    let departmentGoalsPayload = context.state.departmentGoals;

    for (let i = 0; i < departmentGoalsPayload.length; i++) {
      if (
        departmentGoalsPayload[i].departmentId ==
          departmentGoals.departmentId &&
        departmentGoalsPayload[i].projectId == response.projectId
      ) {
        departmentGoals.projectId = response.projectId;
        departmentGoalsPayload[i] = departmentGoals;
        break;
      }
    }
    context.commit("departmentGoals", departmentGoalsPayload);

    return 201;
  },

  // PATCH Requests //

  // Publish company project
  async patchPublishProject(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/publish-project",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departments: payload.departments,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyReportsPayload = context.state.companyReports;
    let companyGoalsPayload = context.state.companyGoals;
    let departmentGoalsPayload = context.state.departmentGoals;

    for (let i = 0; i < companyReportsPayload.length; i++) {
      if (companyReportsPayload[i].projectId == response._id) {
        companyReportsPayload[i] = {
          projectId: response._id,
          companyId: response.companyId,
          title: response.title,
          status: response.status,
          endDate: response.endDate,
          created: response.created,
        };
        break;
      }
    }

    response.companyGoals.forEach((companyGoal) => {
      companyGoal.projectId = response._id;
      for (let i = 0; i < companyGoalsPayload.length; i++) {
        if (companyGoalsPayload[i].goalId == companyGoal.goalId) {
          companyGoalsPayload[i] = companyGoal;
          break;
        }
      }
    });

    response.departments.forEach((department) => {
      department.projectId = response._id;
      let departmentFound = false;
      for (let i = 0; i < departmentGoalsPayload.length; i++) {
        if (departmentGoalsPayload[i].departmentId == department.departmentId) {
          departmentGoalsPayload[i] = department;
          departmentFound = true;
          break;
        }
      }
      if (!departmentFound) {
        departmentGoalsPayload.push(department);
      }
    });

    context.commit("companyReports", companyReportsPayload);
    context.commit("companyGoals", companyGoalsPayload);
    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },
  // update a project
  async patchUpdateProject(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/update-project",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            projectId: payload.projectId,
            companyId: companyId,
            title: payload.title,
            endDate: payload.endDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyReports = context.state.companyReports;

    for (let i = 0; i < companyReports.length; i++) {
      if (companyReports[i].projectId == response._id) {
        companyReports[i] = {
          projectId: response._id,
          companyId: response.companyId,
          title: response.title,
          status: response.status,
          endDate: response.endDate,
          created: response.created,
        };
        break;
      }
    }

    context.commit("companyReports", companyReports);

    return 200;
  },
  // Update company Goal
  async patchCompanyGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/update-company-goal",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            goalId: payload.goalId,
            title: payload.title || null,
            achievement: payload.achievement || null,
            context: payload.context || null,
            value: payload.value || null,
            status: payload.status || null,
            comments: payload.comments || null,
            completionDate: payload.completionDate || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let goal = response.goal;

    let companyGoals = context.state.companyGoals;
    for (let i = 0; i < companyGoals.length; i++) {
      if (companyGoals[i].goalId == goal.goalId) {
        goal.projectId = response.projectId;
        companyGoals[i] = goal;
        break;
      }
    }
    context.commit("companyGoals", companyGoals);

    return 200;
  },
  // Update department goal
  async patchDepartmentGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/update-department-goal",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            goalId: payload.goalId,
            title: payload.title || null,
            achievement: payload.achievement || null,
            context: payload.context || null,
            value: payload.value || null,
            status: payload.status || null,
            comments: payload.comments || null,
            completionDate: payload.completionDate || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let departmentGoals = response.department;

    let departmentGoalsPayload = context.state.departmentGoals;
    for (let i = 0; i < departmentGoalsPayload.length; i++) {
      if (
        departmentGoalsPayload[i].departmentId == departmentGoals.departmentId
      ) {
        departmentGoals.projectId = response.projectId;
        departmentGoalsPayload[i] = departmentGoals;
        break;
      }
    }
    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },
  // Update user Goal
  async patchUserGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/update-goal",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: payload.userId,
            departmentId: payload.departmentId,
            goalId: payload.goalId,
            title: payload.title || null,
            achievement: payload.achievement || null,
            context: payload.context || null,
            value: payload.value || null,
            status: payload.status || null,
            comments: payload.comments || null,
            completionDate: payload.completionDate || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let goal = response.goal;

    let userGoals = context.state.userGoals;
    for (let i = 0; i < userGoals.length; i++) {
      if (userGoals[i].goalId == goal.goalId) {
        goal.userId = response.userId;
        userGoals[i] = goal;
        break;
      }
    }
    context.commit("userGoals", userGoals);

    return 200;
  },
  // Update report for user
  async patchUserReport(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/update-report",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            userId: payload.userId,
            feedback: payload.feedback,
            status: payload.status,
            goals: payload.goals,
            points: payload.points,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let userGoals = context.state.userGoals;
    for (let i = 0; i < response.userGoals.length; i++) {
      for (let j = 0; j < userGoals.length; j++) {
        if (userGoals[j].goalId == response.userGoals[i].goalId) {
          response.userGoals[i].userId = response.userId;
          userGoals[j] = response.userGoals[i];
          break;
        }
      }
    }

    let userReports = context.state.userReports;
    for (let i = 0; i < response.reports.length; i++) {
      let reportFound = false;
      response.reports[i].userId = response.userId;
      for (let j = 0; j < userReports.length; j++) {
        if (userReports[j].reportId == response.reports[i].reportId) {
          userReports[j] = response.reports[i];
          reportFound = true;
          break;
        }
      }
      if (!reportFound) {
        userReports.push(response.reports[i]);
      }
    }

    context.commit("userGoals", userGoals);
    context.commit("userReports", userReports);

    return 200;
  },
  // Update report for user
  async patchDepartmentReport(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/update-department-report",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            status: payload.status,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let departmentGoals = response.department;
    let departmentGoalsPayload = context.state.departmentGoals;

    for (let i = 0; i < departmentGoalsPayload.length; i++) {
      if (
        departmentGoalsPayload[i].departmentId ==
          departmentGoals.departmentId &&
        departmentGoalsPayload[i].projectId == response.projectId
      ) {
        departmentGoals.projectId = response.projectId;
        departmentGoalsPayload[i] = departmentGoals;
        break;
      }
    }
    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },
  // Publish company report
  async patchPublishUserReport(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/publish-goals",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            userId: payload.userId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let userGoals = context.state.userGoals;
    for (let i = 0; i < response.userGoals.length; i++) {
      for (let j = 0; j < userGoals.length; j++) {
        if (userGoals[j].goalId == response.userGoals[i].goalId) {
          response.userGoals[i].userId = response.userId;
          userGoals[j] = response.userGoals[i];
          break;
        }
      }
    }

    let userReports = context.state.userReports;
    for (let i = 0; i < response.reports.length; i++) {
      let reportFound = false;
      response.reports[i].userId = response.userId;
      for (let j = 0; j < userReports.length; j++) {
        if (
          userReports[j].reportId == response.reports[i].reportId &&
          userReports[j].userId == response.userId
        ) {
          userReports[j] = response.reports[i];
          reportFound = true;
          break;
        }
      }
      if (!reportFound) {
        userReports.push(response.reports[i]);
      }
    }

    context.commit("userGoals", userGoals);
    context.commit("userReports", userReports);

    return 200;
  },
  // Publish goals for users
  async patchPublishUserReports(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/publish-user-goals",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            userIds: payload.userIds,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    console.log(response);

    let userGoals = context.state.userGoals;
    let userReports = context.state.userReports;

    for (let i = 0; i < response.userGoals.length; i++) {
      for (let j = 0; j < response.userGoals[i].goals.length; j++) {
        for (let k = 0; k < userGoals.length; k++) {
          if (userGoals[k].goalId == response.userGoals[i].goals[j].goalId) {
            response.userGoals[i].goals[j].userId =
              response.userGoals[i].userId;
            userGoals[k] = response.userGoals[i].goals[j];
            break;
          }
        }
      }

      for (let j = 0; j < response.userGoals[i].reports.length; j++) {
        let reportFound = false;
        response.userGoals[i].reports[j].userId = response.userGoals[i].userId;
        for (let k = 0; k < userReports.length; k++) {
          if (
            userReports[k].reportId ==
              response.userGoals[i].reports[j].reportId &&
            userReports[k].userId == response.userGoals[i].userId
          ) {
            userReports[k] = response.userGoals[i].reports[j];
            reportFound = true;
            break;
          }
        }
        if (!reportFound) {
          userReports.push(response.userGoals[i].reports[j]);
        }
      }
    }

    console.log(userReports);
    context.commit("userGoals", userGoals);
    context.commit("userReports", userReports);

    return 200;
  },
  // Publish company report
  async patchPublishDepartmentReport(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let goals;

    try {
      goals = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/publish-department-report",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            status: payload.status,
          }),
        }
      );
      goals = await goals.json();
    } catch (err) {
      return 500;
    }

    let departmentGoals = goals.department;
    let departmentGoalsPayload = context.state.departmentGoals;

    for (let i = 0; i < departmentGoalsPayload.length; i++) {
      if (
        departmentGoalsPayload[i].departmentId ==
          departmentGoals.departmentId &&
        departmentGoalsPayload[i].projectId == goals.projectId
      ) {
        departmentGoals.projectId = goals.projectId;
        departmentGoalsPayload[i] = departmentGoals;
        break;
      }
    }

    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },
  // Complete all reports for users
  async patchCompleteUserReports(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/user-goals/complete-reports",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            reportId: payload.reportId,
            userIds: payload.userIds,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let userGoals = context.state.userGoals;
    let userReports = context.state.userReports;

    for (let i = 0; i < response.userGoals.length; i++) {
      for (let j = 0; j < response.userGoals[i].goals.length; j++) {
        for (let k = 0; k < userGoals.length; k++) {
          if (userGoals[k].goalId == response.userGoals[i].goals[j].goalId) {
            response.userGoals[i].goals[j].userId =
              response.userGoals[i].userId;
            userGoals[k] = response.userGoals[i].goals[j];
            break;
          }
        }
      }

      for (let j = 0; j < response.userGoals[i].reports.length; j++) {
        let reportFound = false;
        response.userGoals[i].reports[j].userId = response.userGoals[i].userId;
        for (let k = 0; k < userReports.length; k++) {
          if (
            userReports[k].reportId ==
              response.userGoals[i].reports[j].reportId &&
            userReports[k].userId == response.userGoals[i].userId
          ) {
            userReports[k] = response.userGoals[i].reports[j];
            reportFound = true;
            break;
          }
        }
        if (!reportFound) {
          userReports.push(response.userGoals[i].reports[j]);
        }
      }
    }

    console.log(userReports);
    context.commit("userGoals", userGoals);
    context.commit("userReports", userReports);

    return 200;
  },
  // Publish project goals
  async patchPublishProjectGoals(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/publish-goals",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyGoalsPayload = context.state.companyGoals;
    let departmentGoalsPayload = context.state.departmentGoals;

    response.companyGoals.forEach((companyGoal) => {
      companyGoal.projectId = response._id;
      for (let i = 0; i < companyGoalsPayload.length; i++) {
        if (companyGoalsPayload[i].goalId == companyGoal.goalId) {
          companyGoalsPayload[i] = companyGoal;
          break;
        }
      }
    });

    response.departments.forEach((department) => {
      department.projectId = response._id;
      let departmentFound = false;
      for (let i = 0; i < departmentGoalsPayload.length; i++) {
        if (departmentGoalsPayload[i].departmentId == department.departmentId) {
          departmentGoalsPayload[i] = department;
          departmentFound = true;
          break;
        }
      }
      if (!departmentFound) {
        departmentGoalsPayload.push(department);
      }
    });

    context.commit("companyGoals", companyGoalsPayload);
    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },

  // End active project
  async patchEndProject(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/end-project",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let companyReportsPayload = context.state.companyReports;
    let companyGoalsPayload = context.state.companyGoals;
    let departmentGoalsPayload = context.state.departmentGoals;

    for (let i = 0; i < companyReportsPayload.length; i++) {
      if (companyReportsPayload[i].projectId == response._id) {
        companyReportsPayload[i] = {
          projectId: response._id,
          companyId: response.companyId,
          title: response.title,
          status: response.status,
          endDate: response.endDate,
          created: response.created,
        };
        break;
      }
    }

    response.companyGoals.forEach((companyGoal) => {
      companyGoal.projectId = response._id;
      for (let i = 0; i < companyGoalsPayload.length; i++) {
        if (companyGoalsPayload[i].goalId == companyGoal.goalId) {
          companyGoalsPayload[i] = companyGoal;
          break;
        }
      }
    });

    response.departments.forEach((department) => {
      department.projectId = response._id;
      for (let i = 0; i < departmentGoalsPayload.length; i++) {
        if (departmentGoalsPayload[i].goalId == department.departmentId) {
          departmentGoalsPayload[i] = department;
          break;
        }
      }
    });

    context.commit("companyReports", companyReportsPayload);
    context.commit("companyGoals", companyGoalsPayload);
    context.commit("departmentGoals", departmentGoalsPayload);

    return 200;
  },
  // DELETE Requests //

  // delete project
  async deleteProject(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/remove-project",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    let companyReportsPayload = context.state.companyReports.filter(
      (report) => report.projectId != payload.projectId
    );
    let companyGoalsPayload = context.state.companyGoals.filter(
      (goal) => goal.projectId != payload.projectId
    );
    let departmentGoalsPayload = context.state.departmentGoals.filter(
      (department) => department.projectId != payload.projectId
    );

    context.commit("companyReports", companyReportsPayload);
    context.commit("companyGoals", companyGoalsPayload);
    context.commit("departmentGoals", departmentGoalsPayload);

    return 201;
  },
  // delete company goal
  async deleteCompanyGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/company-goals/remove-company-goal",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            goalId: payload.goalId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    let companyGoals = context.state.companyGoals;
    companyGoals = companyGoals.filter((goal) => goal.goalId != payload.goalId);

    context.commit("companyGoals", companyGoals);

    return 201;
  },
  // delete department goal
  async deleteDepartmentGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/company-goals/remove-department-goal",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            projectId: payload.projectId,
            departmentId: payload.departmentId,
            goalId: payload.goalId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    let departmentGoals = context.state.departmentGoals;
    for (let i = 0; i < departmentGoals.length; i++) {
      if (
        departmentGoals[i].projectId == payload.projectId &&
        departmentGoals[i].departmentId == payload.departmentId
      ) {
        departmentGoals[i].goals = departmentGoals[i].goals.filter(
          (gol) => gol.goalId != payload.goalId
        );
        break;
      }
    }

    context.commit("departmentGoals", departmentGoals);

    return 201;
  },
  // delete user goal
  async deleteUserGoal(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/user-goals/remove-goal", {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          userId: payload.userId,
          goalId: payload.goalId,
        }),
      });
    } catch (err) {
      return 500;
    }

    let userGoals = context.state.userGoals.filter(
      (goal) => goal.goalId != payload.goalId
    );

    context.commit("userGoals", userGoals);

    return 201;
  },
};
